import axios from "axios";
import { API_ADMIN } from "../../utils/constants/Api";
import { ReportExampleFileModel } from "../models/ReportExampleFileModel";
import { ReportFileModel } from "../models/ReportFileModel";
import { ReportModel } from "../models/ReportModel";

export default {
	requestReport(report:ReportModel):Promise<ReportModel> {
		return axios.post(`${API_ADMIN}custom_reports`, report)
			.then(({data}) => {
				return new ReportModel(data);
			})
	},
	updateReport(reportId:number, report:ReportModel):Promise<ReportModel> {
		return axios.put(`${API_ADMIN}custom_reports/${reportId}`, report)
			.then(({data}) => {
				return new ReportModel(data);
			})
	},
	generateReportFile(reportId:number, filterForm?:any):Promise<ReportFileModel> {
		return axios.post(`${API_ADMIN}custom_reports/${reportId}/generate`, filterForm)
			.then(({data}) => {
				return new ReportFileModel(data);
			})
	},
	getReportList():Promise<ReportModel[]> {
		return axios.get(`${API_ADMIN}custom_reports`)
			.then(({data}) => {
				return (data || []).map((info: ReportModel) => new ReportModel(info))
			})
	},
	getReportById(reportId: number):Promise<ReportModel> {
		return axios.get(`${API_ADMIN}custom_reports/${reportId}`)
			.then(({data}) => {
				return new ReportModel(data)
			})
	},
	getReportFileList(reportId:number):Promise<ReportFileModel[]> {
		return axios.get(`${API_ADMIN}custom_reports/${reportId}/files`)
			.then(({data}) => {
				return (data || []).map((info: ReportFileModel) => new ReportFileModel(info))
			})
	},
	uploadReportExampleList(reportId: number, reportExampleList: ReportExampleFileModel[]):Promise<ReportModel> {
		return axios.post(`${API_ADMIN}custom_reports/${reportId}/examples`, reportExampleList)
			.then(({data}) => {
				return new ReportModel(data)
			})
	},
	deleteReport(reportId:number):Promise<any> {
		return axios.delete(`${API_ADMIN}custom_reports/${reportId}`)
			.then(({data}) => {
				return data;
			})
	},
	deleteReportExample(reportId:number, url:string):Promise<any> {
		return axios.post(`${API_ADMIN}custom_reports/${reportId}/examples/delete`, [url])
			.then(({data}) => {
				return data;
			})
	},
}
